import React, { useEffect, useState } from "react";
import {
  CardContent,
  Card,
  Grid,
  Alert,
  AlertTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import ResponsiveDrawer from "../components/ClippedResponsiveDrawer";
import { getPublicImagePath } from "../App";
import { getAlertMessageData } from "../utils/GetAlertMessagesData";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';
import { useLocalStorage } from "../utils/LocalStorageHook";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    image: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    primary: {
      marginTop: '2px',
      alignItems: 'center',
      justifyContent: 'center',
      top: `50%`,
      left: `50%`,
    },
    overlay: {
      marginTop: '70px',
    },
  })
);

export default function MaintenancePage() {
  const classes = useStyles();
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", '4100');
  const [open, setOpen] = React.useState(false);
  const [alertMessage, setAlertMessage] = useState<string>();
  useEffect(() => {
    getAlertMessageData(salesOrg).then((v) => {

      for (let i = 0; i < v.data?.length; i++) {
        let currentDate = new Date();
        if ((currentDate >= new Date(v.data[i].startDate)) && (currentDate <= new Date(v.data[i].endDate))) {
          setAlertMessage(v.data[i].message);
          setOpen(true);
        }
      }
    });
  }, [])

  const AlertSuccess = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref,
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  return (
    <div className={classes.overlay}>
      <ResponsiveDrawer title="Maintenance Page">
        <Snackbar
          open={open}
          style={{ marginTop: '40px', width: '100%', textAlign: 'center' }}
          anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
          autoHideDuration={6000}
        >
          <AlertSuccess onClose={handleClose} severity='error' sx={{ width: '99%', textAlign: 'center', justifyContent: 'center' }}>
            {alertMessage}
          </AlertSuccess>
        </Snackbar>
        <Grid container spacing={1} className={classes.primary}>
          <Grid item>
            <Card className={classes.primary}>
              <CardContent>
                <Alert severity="error">
                  <AlertTitle> Schedule Maintenance</AlertTitle>
                  Sorry we are down for a scheduled maintenance
                </Alert>
                <img className={classes.image} src={getPublicImagePath(`/VendBroken.png`)} alt={"Maintenance Page"}></img>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </ResponsiveDrawer>
    </div>
  );

}
